/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Digital_AccessInputs */

const en_gift_digital_access = /** @type {(inputs: Gift_Digital_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send this directly to a friend. We'll give you a secure link to share for instant digital access.`)
};

const es_gift_digital_access = /** @type {(inputs: Gift_Digital_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envía esto directamente a un amigo. Te daremos un enlace seguro para acceso digital instantáneo.`)
};

const fr_gift_digital_access = /** @type {(inputs: Gift_Digital_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyez ceci directement à un ami. Nous vous donnerons un lien sécurisé à partager pour un accès numérique instantané.`)
};

const de_gift_digital_access = /** @type {(inputs: Gift_Digital_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sende dies direkt an einen Freund. Wir geben dir einen sicheren Link zum Teilen für sofortigen digitalen Zugang.`)
};

const id_gift_digital_access = /** @type {(inputs: Gift_Digital_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim ini langsung ke teman. Kami akan memberi Anda tautan aman untuk dibagikan untuk akses digital instan.`)
};

/** @type {(inputs: Gift_Digital_AccessInputs) => LocalizedString} */
const ja_gift_digital_access = en_gift_digital_access;

/** @type {(inputs: Gift_Digital_AccessInputs) => LocalizedString} */
const zh_gift_digital_access = en_gift_digital_access;

/** @type {(inputs: Gift_Digital_AccessInputs) => LocalizedString} */
const ar_gift_digital_access = en_gift_digital_access;

/** @type {(inputs: Gift_Digital_AccessInputs) => LocalizedString} */
const it_gift_digital_access = en_gift_digital_access;

/** @type {(inputs: Gift_Digital_AccessInputs) => LocalizedString} */
const ru_gift_digital_access = en_gift_digital_access;

/** @type {(inputs: Gift_Digital_AccessInputs) => LocalizedString} */
const pt_gift_digital_access = en_gift_digital_access;

/** @type {(inputs: Gift_Digital_AccessInputs) => LocalizedString} */
const ko_gift_digital_access = en_gift_digital_access;

/**
* | output |
* | --- |
* | "Send this directly to a friend. We'll give you a secure link to share for instant digital access." |
*
* @param {Gift_Digital_AccessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const gift_digital_access = /** @type {((inputs?: Gift_Digital_AccessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Digital_AccessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gift_digital_access(inputs)
	if (locale === "es") return es_gift_digital_access(inputs)
	if (locale === "fr") return fr_gift_digital_access(inputs)
	if (locale === "de") return de_gift_digital_access(inputs)
	if (locale === "ja") return ja_gift_digital_access(inputs)
	if (locale === "zh") return zh_gift_digital_access(inputs)
	if (locale === "ar") return ar_gift_digital_access(inputs)
	if (locale === "id") return id_gift_digital_access(inputs)
	if (locale === "it") return it_gift_digital_access(inputs)
	if (locale === "ru") return ru_gift_digital_access(inputs)
	if (locale === "pt") return pt_gift_digital_access(inputs)
	return ko_gift_digital_access(inputs)
});